import { BuiltinInstanceMemberValue } from '../BuiltinInstanceMemberValue';
export class ArrayLength extends BuiltinInstanceMemberValue {
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.arrayLength);
        sb.emitHelper(node, options, sb.helpers.wrapNumber);
    }
}

//# sourceMappingURL=length.js.map
